// extracted by mini-css-extract-plugin
module.exports = {"warper":"AccountDetailViewSection_warper__2btrO","container":"AccountDetailViewSection_container__3rN4m"};